<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentTransferReport.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentTransferReport.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('studentTransferReport.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentTransferReport.branchName')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentTransferReport.registeredDate')
                      }}</label>
                      <a-range-picker
                        format="DD-MM-YYYY"
                        :defaultValue="rangeDate"
                        :defaultPickerValue="rangeDate"
                        @change="dateRangeChange"
                      >
                        <template slot="renderExtraFooter"></template>
                      </a-range-picker>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('studentTransferReport.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'studentTransferReport',
  data() {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      rangeDate: [moment(), moment()],
      model: {
        branch_id: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', ['getBranch', 'studentTransfer']),
    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id = this.$store.state.authUser.default_branch_id
      })
      this.loading = false
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.studentTransfer(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'reportAcademic/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'reportAcademic/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    }
  }
}
</script>
